export default __webpack_public_path__ + "static/demo-0900a8d3f9a7ce4cdcc803c99946e152.jpg";